<div [ngClass]="classSize">
  <img src="assets/images/logo/logo-caca-pix.png" alt="Logo Caça PIX" />
</div>
